import { RegisterWidget, Widget } from '../../lib/widget';
import template from './overview.html';

@RegisterWidget({tag: 'dpo-overview', displayName: 'DPO Overview', section: 'DPO', template: template})
export class DPOOverview extends Widget {}